import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { TabContent } from "../../SharedComponents/TabContent/TabContent";
import { UserAccountDetails } from "../UserAccountDetails/UserAccountDetails";
import { UserAccountUsers } from "../UserAccountUsers/UserAccountUsers";
import "./UserProfileDetails.css";

export const UserProfileDetails = ({ accountId }) => {
  const { t } = useTranslation();
  const { data: currentUserData } = useQuery(getUserInformation);

  const userRole = currentUserData?.user?.roles?.sso?.find(
    (x) => x.accountId === accountId
  );

  return (
    <div className="UserProfileDetails">
      <Tabs style={{ height: "calc(100% - 129px)" }}>
        <TabList className="UserProfileDetails__tablist">
          {userRole?.role !== "CUSTOMER" && (
            <Tab className="UserProfileDetails__tablist-tab">
              <TabContent text={t("generic.users")} />
            </Tab>
          )}
          <Tab className="UserProfileDetails__tablist-tab">
            <TabContent text={t("generic.addressAndProfile")} />
          </Tab>
        </TabList>

        {userRole?.role !== "CUSTOMER" && (
          <TabPanel style={{ height: "calc(100% - 55px)" }}>
            <UserAccountUsers accountId={accountId} />
          </TabPanel>
        )}
        <TabPanel style={{ height: "calc(100% - 55px)" }}>
          <UserAccountDetails accountId={accountId} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

const getUserInformation = gql`
  query user {
    user {
      id
      roles
      name
    }
  }
`;
